import {Card} from "../model/types";
import {MainWeddingCard} from "../ui/MainWeddingCard";
import {Picture} from "@/shared/ui/Picture";
import styles from "./MainWedding.module.scss";

type Props = {
    cards: Card[];
}

export const MainWeddingDesktop = ({cards}: Props) => {
    return (
        <div className={`globalContainer`}>
            <div className={styles.cards}>
                {cards.map((card) => {
                    return (
                        <MainWeddingCard key={card.link} card={card} className={styles.card} />
                    );
                })}
                {/*<div className={styles.card}>*/}
                {/*    <Picture*/}
                {/*        src={`/storage/img/main/wedding/06.jpg`}*/}
                {/*        srcMobile={`/storage/img/main/wedding/05_mobile.jpg`}*/}
                {/*        alt={`Свадьба`}*/}
                {/*    />*/}
                {/*</div>*/}
            </div>
        </div>
    );
}
